import React, { Component } from 'react';
import { Modal, RadioButton, FormItem, TextArea } from 'carbon-components-react';
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';
import { TableDefault, Breadcrumb } from '../../../../components';
import { insertDmService } from '../../../../services/Api';

export class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: null,
      urlEdit: '/admin/gestao/budget/',
      urlLoad: '/Orcamento/GetListagem/',
      actionModalAlerta: false,
      showModalBudgetAtual: false,
      showModalBudgetAutomatico: false,
      tipo1: '',
      tipo2: '',
      ids: [],
      tipo: 1,
      budget: null,
      tipoOperacaoExtrato: 1,
      valorAdicional: null,
      motivo: '',
    };
  }

  selectedRow = obj => {
    let tipo1 = null;
    let tipo2 = null;

    obj.rows.forEach((row, i) => {
      const idx = row.cells.length - 1;
      if (i === 0) {
        tipo1 = row.cells[idx].value;
      } else if (tipo1 !== row.cells[idx].value) tipo2 = row.cells[idx].value;
    });

    if (tipo2 != null) {
      this.setState({
        actionModalAlerta: true,
        tipo1,
        tipo2,
        ids: obj.ids,
      });
    } else this.setState({ ids: obj.ids });
  };

  closeModalAlerta = () => {
    this.setState({
      actionModalAlerta: false,
    });
  };

  toggleModalBudgetAutomatico = () => {
    this.setState(prevState => ({
      showModalBudgetAutomatico: !prevState.showModalBudgetAutomatico,
    }));
  };

  toggleModalBudgetAtual = () => {
    this.setState(prevState => ({ showModalBudgetAtual: !prevState.showModalBudgetAtual }));
  };

  actionModalBudgetAutomatico = async () => {
    const { ids, budget, tipo } = this.state;
    const obj = {
      Usuarios: ids,
      ValorAtual: 0,
      ValorMensal:
        typeof budget !== 'string' ? budget : budget.replace(/[Rr$ .]/g, '').replace(',', '.'),
      StatusOrcamento: tipo,
    };

    try {
      await insertDmService('/Orcamento', obj);
      toast.success('Dados atualizados com sucesso');
      await this.tableList.getItems();
      this.tableList.selectedRows.forEach(resultado => this.tableList.selectRow(resultado.id));
    } catch (e) {
      this.errorHandler(e);
    }
    this.toggleModalBudgetAutomatico();
    this.setState({ budget: null });
  };

  actionModalBudgetAtual = async () => {
    const { ids, tipoOperacaoExtrato, motivo, valorAdicional } = this.state;
    const obj = {
      Usuarios: ids,
      ValorAtual:
        typeof valorAdicional !== 'string'
          ? valorAdicional
          : valorAdicional.replace(/[Rr$ .]/g, '').replace(',', '.'),
      ValorMensal: 0,
      TipoOperacaoExtrato: tipoOperacaoExtrato,
      Motivo: motivo,
    };

    try {
      await insertDmService('/Orcamento', obj);
      toast.success('Dados atualizados com sucesso');
      this.tableList.getItems();
      this.toggleModalBudgetAtual();
      this.tableList.selectedRows.forEach(resultado => this.tableList.selectRow(resultado.id));
      this.setState({ motivo: '', valorAdicional: null });
    } catch (e) {
      this.errorHandler(e);
    }
  };

  errorHandler = err => {
    if (typeof err.error.response.data.modelState !== 'undefined') {
      let error = 'Ocorreu o seguinte erro: ';

      const erros = err.error.response.data.modelState;
      for (const p in erros) {
        let name = p.replace('model.', '');
        name = name[0].toUpperCase() + name.slice(1);
        error += `${erros[p]}; `;
      }
      toast.warning(error.trim());
    } else {
      toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
    }
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value /* , isEdited: true */ });
  };

  onChangeTipo = tipo => {
    this.setState({ tipo });
  };

  onChangeTipoOperacao = tipo => {
    this.setState({ tipoOperacaoExtrato: tipo });
  };

  render() {
    // const { match } = this.props;
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      tipo1,
      tipo2,
      ids,
      tipo,
      budget,
      motivo,
      valorAdicional,
      tipoOperacaoExtrato,
      actionModalAlerta,
      showModalBudgetAtual,
      showModalBudgetAutomatico,
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title="Gestão de Budgets"
          description="Gerencie os budgets dos usuários."
          renderRight={(() => (
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-outlined h-sm-margin"
                type="submit"
                onClick={this.toggleModalBudgetAutomatico}
                disabled={ids.length === 0}
              >
                Alterar Budget Automático
              </button>
              <button
                type="submit"
                className="bx--btn btn-secondary-color h-sm-margin"
                onClick={this.toggleModalBudgetAtual}
                disabled={ids.length === 0}
              >
                Alterar Budget Atual
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper budget-management screen-table-budget">
          <TableDefault
            search={search}
            order={order}
            orderBy={orderBy}
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            forbidSelectionOfConflictingTypes
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            onRef={ref => {
              this.tableList = ref;
            }}
            onRowSelected={rows => {
              this.selectedRow(rows);
            }}
            displayActions={false}
          />

          <Modal
            className="no-secundary-btn"
            open={actionModalAlerta}
            onRequestSubmit={() => this.closeModalAlerta()}
            modalHeading="Alerta"
            primaryButtonText="Ok, entendi."
          >
            <div>
              <p>
                Você não pode selecionar:
                <br />
                <br />
                {'Pessoas com status diferentes de saldo ('}
                <strong>{tipo1}</strong>
                {' e '}
                <strong>{tipo2}</strong>
                {').'}
              </p>
            </div>
          </Modal>
          <Modal
            open={showModalBudgetAutomatico}
            onRequestSubmit={this.actionModalBudgetAutomatico}
            onRequestClose={this.toggleModalBudgetAutomatico}
            modalHeading="Setar Budget Automático"
            primaryButtonText="Confirmar"
            secondaryButtonText="Cancelar"
            className="ofauto"
          >
            <div>
              <p>
                Insira o valor que você deseja para
                {ids.length < 2 ? ' a ' : ' as '}
                <strong>{ids.length < 2 ? ' pessoa ' : `${ids.length} pessoas`}</strong>
                {` `} 
                selecionada
                {ids.length < 2 ? '' : 's'}
                {'.'}
              </p>
              <FormItem>
                <label className="bx--label">
                  <strong>Budget Mensal</strong>
                  (Crédito Automático)
                </label>
                <NumberFormat
                  getInputRef={ref => {
                    this.budgetRef = ref;
                  }}
                  id="budget"
                  className="bx--text-input bx--text__input"
                  fixedDecimalScale
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix="R$ "
                  placeholder="R$ 0,00"
                  value={budget}
                  allowNegative={false}
                  decimalScale={2}
                  onValueChange={(values, e) => {
                    this.setState({
                      [e.target.id]: values.value ? Number(values.value) : null,
                      // isEdited: true,
                    });
                  }}
                  onFocus={() => {
                    if (!budget && this.budgetRef) {
                      this.budgetRef.value = '';
                    }
                  }}
                />
              </FormItem>
              <FormItem>
                <RadioButton
                  name="tipo"
                  onChange={this.onChangeTipo}
                  checked={tipo === 1}
                  value={1}
                  labelText="Recorrente"
                />
                <span className="legend-budget">
                  O budget entra automático e soma com o valor que já estiver.
                </span>
              </FormItem>
              <FormItem>
                <RadioButton
                  name="tipo"
                  onChange={this.onChangeTipo}
                  checked={tipo === 2}
                  value={2}
                  labelText="Saldo incial"
                />
                <span className="legend-budget">
                  O budget entra automático e zera o valor que já estiver.
                </span>
              </FormItem>
            </div>
          </Modal>
          <Modal
            open={showModalBudgetAtual}
            onRequestSubmit={this.actionModalBudgetAtual}
            onRequestClose={this.toggleModalBudgetAtual}
            modalHeading="Alterar Budget Atual"
            primaryButtonText="Confirmar"
            secondaryButtonText="Cancelar"
            className="ofauto"
          >
            <div>
              <div className="bx--modal-content">
                <p>
                  Insira o valor que você deseja para
                  {ids.length < 2 ? ' a ' : ' as '}
                  <strong>{ids.length < 2 ? 'pessoa ' : `${ids.length} pessoas `}</strong>
                  selecionada
                  {ids.length < 2 ? '' : 's'}
                  {'.'}
                </p>
                <FormItem>
                  <RadioButton
                    name="tipoOperacaoExtrato"
                    onChange={this.onChangeTipoOperacao}
                    checked={tipoOperacaoExtrato === 1}
                    value={1}
                    labelText="Crédito"
                  />
                </FormItem>
                <FormItem>
                  <RadioButton
                    name="tipoOperacaoExtrato"
                    onChange={this.onChangeTipoOperacao}
                    checked={tipoOperacaoExtrato === 2}
                    value={2}
                    labelText="Débito"
                  />
                </FormItem>
                <FormItem>
                  <RadioButton
                    name="tipoOperacaoExtrato"
                    onChange={this.onChangeTipoOperacao}
                    checked={tipoOperacaoExtrato === 3}
                    value={3}
                    labelText="Saldo incial"
                  />
                </FormItem>
                <FormItem>
                  <label htmlFor="valorAdicional" className="bx--label">
                    Adicionar valor
                  </label>
                  <NumberFormat
                    getInputRef={ref => {
                      this.valorAdicionalRef = ref;
                    }}
                    id="valorAdicional"
                    className="bx--text-input bx--text__input"
                    decimalSeparator=","
                    prefix="R$ "
                    fixedDecimalScale
                    thousandSeparator="."
                    placeholder="R$ 0,00"
                    value={valorAdicional}
                    allowNegative={false}
                    decimalScale={2}
                    onValueChange={(values, e) => {
                      this.setState({
                        [e.target.id]: values.value ? Number(values.value) : null,
                        // isEdited: true,
                      });
                    }}
                    onFocus={() => {
                      if (!valorAdicional && this.valorAdicionalRef) {
                        this.valorAdicionalRef.value = '';
                      }
                    }}
                  />
                </FormItem>
                <FormItem>
                  <TextArea
                    id="motivo"
                    labelText="Motivo"
                    onChange={this.onChangeText}
                    value={motivo}
                    placeholder="Ex: ajuste de budget."
                    invalidText="Preencha uma descrição com no mínimo 10 caracteres"
                    invalid={motivo.length < 10}
                  />
                </FormItem>
              </div>
            </div>
          </Modal>
        </section>
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Gestao/Budget/List.js